import { TDevice } from '@cian/utils';

import { FSK_BANNER, FSK_BANNER_PLACE } from './fsk';
import { STONE_BANNER } from './stone';

import type { PParams } from '../containers/Adfox/components/AdfoxBanner/types';
import type { TAdBannerMicrofrontendParameters } from '../containers/AdBannerMicrofrontendContainer';

/**
 * Размещение adfox-баннера спецпроекта на карте.
 *
 * Эти же значения уезжают в микрофронтенд рекламных баннеров: place/pParams/sizes должны
 * совпадать с легаси-размещением, иначе будет отдаваться другая рекламная кампания.
 */
export const ADFOX_SPECIAL_PROJECT_P_PARAMS: Record<TDevice, PParams> = {
  desktop: { p1: 'dnoim', p2: 'jrxq' },
  phone: { p1: 'dnoin', p2: 'jrxq' },
  tablet: { p1: 'dnoin', p2: 'jrxq' },
};

/**
 * Размер контейнера, который отдаётся в @cian/adfox-component на легаси-пути.
 * Это не размер карточки: легаси-шаблон спецпроекта позиционируется сам и этот размер игнорирует.
 */
export const ADFOX_SPECIAL_PROJECT_SIZE: Record<TDevice, TAdBannerMicrofrontendParameters['sizes']> = {
  desktop: { width: '240px', height: 400 },
  phone: { width: '100%', height: 64 },
  tablet: { width: '100%', height: 64 },
};

/**
 * Реальный размер карточки баннера — тот, что легаси-шаблон задаёт своей вёрсткой
 * (desktop-banner 360x78, mobile-banner 100%x64).
 *
 * Микрофронтенду размер нужно передать явно: он рисует карточку по `sizes`, а не по своей вёрстке.
 * Если отдать ему размер контейнера adfox (240x400), баннер растянется на весь слот.
 */
export const ADFOX_SPECIAL_PROJECT_CARD_SIZE: Record<TDevice, TAdBannerMicrofrontendParameters['sizes']> = {
  desktop: { width: '360px', height: 78 },
  phone: { width: '100%', height: 64 },
  tablet: { width: '100%', height: 64 },
};

export const ADFOX_BANNER_PLACE: Record<TDevice, string> = {
  desktop: 'bottom_right_map_corner',
  phone: 'above_header',
  tablet: 'above_header',
};

const BANNER_PLACE_BY_DEVELOPER: Record<number, Record<TDevice, string>> = {
  [FSK_BANNER.developerId]: FSK_BANNER_PLACE,
  [STONE_BANNER.developerId]: ADFOX_BANNER_PLACE,
};

/** Место показа для аналитики: зависит и от девайса, и от застройщика */
export function getAdfoxSpecialProjectPlace(deviceType: TDevice, developerId: number): string {
  return (BANNER_PLACE_BY_DEVELOPER[developerId] ?? ADFOX_BANNER_PLACE)[deviceType];
}
